import { cva, type VariantProps } from 'class-variance-authority';
import { ComponentProps } from 'react';
import { cn } from '../utils/className';

const badgeVariants = cva(
  [
    'inline-flex items-center gap-[6px] px-2 py-1 rounded-full w-fit max-w-full',
    'size-caption font-regular',
  ],
  {
    variants: {
      variant: {
        success: 'bg-surface-positive-support text-green-600',
        warning: 'bg-surface-warning-support text-amber-600',
        error: 'bg-surface-negative-support text-red-600',
        info: 'bg-surface-focus-support text-blue-600',
        neutral: 'bg-surface-primary-support text-secondary',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  }
);

const dotVariants = cva('h-1 w-1 shrink-0 rounded-full', {
  variants: {
    variant: {
      success: 'bg-positive',
      warning: 'bg-warning',
      error: 'bg-negative',
      info: 'bg-focus',
      neutral: 'bg-secondary',
    },
  },
  defaultVariants: {
    variant: 'neutral',
  },
});

export interface BadgeProps
  extends ComponentProps<'div'>, VariantProps<typeof badgeVariants> {
  showDot?: boolean;
}

export function Badge({
  variant,
  showDot = true,
  className,
  children,
  ...props
}: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props}>
      {showDot && <div className={dotVariants({ variant })} />}
      <span className='truncate capitalize'>{children}</span>
    </div>
  );
}
